import type { GradeSchemeCreateSchema } from '@repo/schemas/grade-scale/gradeScale';

/**
 * Built-in grading scales offered when assigning a grade mapping to a quiz or
 * assignment. Teachers pick one and may fine-tune its thresholds before saving.
 */
export const GRADE_SCALE_PRESETS: GradeSchemeCreateSchema[] = [
  {
    name: 'Zdane/Nie zdane',
    bands: [
      { name: 'Nie zdane', minPercent: 0, maxPercent: 50 },
      { name: 'Zdane', minPercent: 51, maxPercent: 100 },
    ],
  },
  {
    name: '1-6',
    bands: [
      { name: '1', minPercent: 0, maxPercent: 40 },
      { name: '2', minPercent: 41, maxPercent: 60 },
      { name: '3', minPercent: 61, maxPercent: 70 },
      { name: '4', minPercent: 71, maxPercent: 80 },
      { name: '5', minPercent: 81, maxPercent: 90 },
      { name: '6', minPercent: 91, maxPercent: 100 },
    ],
  },
];
